import { Store } from 'redux'
import { Entity } from '../../app/entity'
import { ApplicationState } from '../../redux/ApplicationState'
import { SnapshotState } from '../../redux/snapshots/SnapshotState'
import SnapshotModel from './snapshotModel'

/**
 * Loader classes like this consilidate all loading operations for a domain
 * concept.
 *
 * They define one (or multiple) load() methods which execute an AJAX call
 * through the Api. You may implement parameter remapping and cache checks in
 * here. For the loaded date there should be a dispatched action through Redux.
 *
 * The Loader also defines a (static) method which handles its own actions and
 * applies the corresponding changes to the global store state.
 */
const Loader = function(store: Store<ApplicationState>, api) {
    this.store = store
    this.api = api

    this.load = parameters => {
        const snapshot = SnapshotModel.fromParameters(parameters)
        parameters = { ...snapshot.toRange(), ...parameters }

        this.api.trigger('XhprofProfilerBundle.Snapshot.data', parameters)
    }
}

const initialGlobalState: SnapshotState = {
    snapshot: null,
}

Loader.handleAction = (globalState: SnapshotState = initialGlobalState, action): SnapshotState => {
    switch (action.type) {
        case 'TIDEWAYS_ROUTE':
            return {
                snapshot: null,
            }
        case 'Snapshot.data.success':
            return {
                ...globalState,
                snapshot: new Entity(action.data),
            }
        case 'Snapshot.data.error':
            return {
                ...globalState,
                snapshot: new Entity().setError(action.error),
            }
    }

    return globalState
}

export default Loader
